import { SellerPageFederatedSeller, useSellerData } from '@fiverr-private/seller_pages_toolbox';

export const useIsHighlightsSectionVisible = () => {
    const { rating, testimonials } = useSellerData(selectSellerSlice);

    return Boolean(rating?.count || testimonials?.length);
};

const selectSellerSlice = (seller: SellerPageFederatedSeller) => ({
    rating: seller.rating,
    testimonials: seller.testimonials,
});
